// String utility functions

/**
 * Capitalize the first character of a string using locale-aware casing.
 * Defaults to Turkish locale to handle i/İ and ı/I correctly.
 */
export function capitalize(value, locale = 'tr-TR') {
  if (!value || typeof value !== 'string') return '';
  const input = value.trim();
  if (input.length === 0) return '';
  const first = input.charAt(0).toLocaleUpperCase(locale);
  const rest = input.slice(1);
  return first + rest;
}

/**
 * Normalize Turkish characters to their ASCII equivalents for searching.
 * Converts: ş→s, ğ→g, ü→u, ö→o, ç→c, ı→i, İ→i
 * Also converts to lowercase for case-insensitive comparison.
 * 
 * @example
 * normalizeTurkish("Türkiye") // returns "turkiye"
 * normalizeTurkish("İstanbul") // returns "istanbul"
 */
export function normalizeTurkish(text) {
  if (!text) return "";
  
  const turkishMap = {
    'ş': 's', 'Ş': 's',
    'ğ': 'g', 'Ğ': 'g',
    'ü': 'u', 'Ü': 'u',
    'ö': 'o', 'Ö': 'o',
    'ç': 'c', 'Ç': 'c',
    'ı': 'i', 'İ': 'i'
  };
  
  return String(text)
    .split('')
    .map(char => turkishMap[char] || char)
    .join('')
    .toLowerCase();
}

/**
 * Slug formatındaki lokasyon adını başlık formatına çevirir (örn. "balayi-otelleri" -> "Balayi Otelleri").
 * API'den gelen görünen ad (Name) kullanılamıyorsa fallback olarak kullanılır.
 * @param {string} hotelName - URL slug veya ham lokasyon
 * @returns {string}
 */
export function formatLocationTitle(hotelName) {
  if (!hotelName || typeof hotelName !== 'string') return '';
  try {
    const decoded = decodeURIComponent(hotelName);
    return decoded
      .replace(/-/g, ' ')
      .split(' ')
      .filter(Boolean)
      .map((word) => {
        const lower = word.toLocaleLowerCase('tr-TR');
        const firstChar = lower.charAt(0).toLocaleUpperCase('tr-TR');
        return `${firstChar}${lower.slice(1)}`;
      })
      .join(' ');
  } catch {
    return hotelName;
  }
}

/**
 * Başlığı h1/h3 semantik yapısı için iki parçaya böler.
 * \n veya <br /> / <br/> ile ayrılmış metinleri destekler.
 * @param {string} title - Bölünecek başlık metni
 * @returns {{ main: string, sub: string|undefined }}
 */
export function splitTitleForHeadings(title) {
  if (!title || typeof title !== "string")
    return { main: title || "", sub: undefined };
  const normalized = title.replace(/<br\s*\/?>/gi, "\n");
  const parts = normalized
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
  return {
    main: parts[0] || title,
    sub: parts[1] || undefined,
  };
}



